import { Link } from "react-router-dom";
import { ArrowRight, Flame, Truck, Sparkles, Heart } from "lucide-react";
import SEO from "@/components/SEO";

export default function About() {
  const aboutJsonLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Booty Breeze",
    "url": "https://bootybreeze.com/about",
    "description":
      "Booty Breeze is a small-batch adult (18+) car air freshener brand. Hand-poured in the USA, shipped tracked with free shipping over $10.",
    "mainEntity": {
      "@type": "Organization",
      "name": "Booty Breeze",
      "url": "https://bootybreeze.com",
      "logo": "https://bootybreeze.com/apple-touch-icon.png",
      "email": "admin@bootybreeze.com",
    },
  };
  return (
    <div className="min-h-screen" data-testid="about-page">
      <SEO
        title="About Booty Breeze — Small-Batch Car Air Fresheners for Grown Drivers"
        description="Booty Breeze is a small-batch adult (18+) car air freshener brand. Hand-poured scents cured for slow release, tracked shipping from the USA, free over $10."
        path="/about"
        jsonLd={aboutJsonLd}
      />

      {/* HERO */}
      <section className="max-w-4xl mx-auto px-6 sm:px-10 pt-20 pb-14 text-center">
        <div className="text-[#A855F7] uppercase text-xs tracking-widest mb-4">
          Our Story
        </div>
        <h1 className="font-display text-5xl sm:text-6xl leading-tight text-white">
          Some fresheners flirt. <br />
          <span className="text-neon-pink">Ours mean it.</span>
        </h1>
        <p className="text-white/70 mt-8 text-lg leading-relaxed max-w-2xl mx-auto">
          Booty Breeze is a small-batch car air freshener brand built for grown
          drivers who want their ride to feel a little more <em>them</em>.
          Nothing generic. Nothing safe. Nothing that smells like the aisle at
          the gas station.
        </p>
      </section>

      {/* THE PROMISE — pillar tiles */}
      <section className="max-w-6xl mx-auto px-6 sm:px-10 py-14 border-t border-white/10">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            {
              icon: Flame,
              title: "Hand-poured, small-batch",
              body:
                "Every freshener is cured and pressed in small batches so the scent lands the way we designed it — bold on the first breath, lingering on the second.",
            },
            {
              icon: Truck,
              title: "Ships from the USA",
              body:
                "We fulfil orders out of the U.S. with tracked shipping. Free shipping on orders over $10 — orders usually ship within 1–2 business days.",
            },
            {
              icon: Heart,
              title: "Adult (18+), unapologetic",
              body:
                "Grown-up branding for a grown-up product. If it makes your grandmother blush, we're doing it right. Not for kids — age gate on the front door.",
            },
          ].map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-2xl border border-white/10 bg-white/[0.02] p-7"
              data-testid={`about-tile-${title.toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-+|-+$/g,'')}`}
            >
              <Icon className="text-[#FF3D8B]" size={22} />
              <h3 className="font-display text-2xl text-white mt-4 leading-tight">
                {title}
              </h3>
              <p className="text-white/60 text-sm mt-3 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* THE SCENTS — brand tone */}
      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-14 border-t border-white/10">
        <div className="text-[#A855F7] uppercase text-xs tracking-widest mb-3">
          The scents
        </div>
        <h2 className="font-display text-4xl text-white leading-tight">
          Six moods. <span className="text-neon-pink">Six ways to hang.</span>
        </h2>
        <div className="text-white/70 mt-6 space-y-4 leading-relaxed">
          <p>
            Every Booty Breeze is a mood, not a flavor. Some lean sweet. Some
            lean sultry. A couple lean clean, and one or two lean grown. None of
            them overlap, and none of them try to be all things at once.
          </p>
          <p>
            One opens fresh and lifts fast. Another burns slow, warm, and low.
            Another is fruit-forward without the sugar-shock. What they share is
            a small-batch cure that lets them last three to four weeks in a
            daily driver — long enough to become a habit, short enough to want
            to try the next one.
          </p>
          <p>
            They're built to be swapped: one for weekday commutes, another for
            the weekend, a third for the passenger you want to notice. Pick two,
            unlock free shipping, and rotate.
          </p>
        </div>
        <Link
          to="/shop"
          data-testid="about-shop-cta"
          className="mt-10 inline-flex items-center gap-2 text-[#FF3D8B] font-semibold text-sm uppercase tracking-widest hover:gap-3 transition-all"
        >
          Meet the scents <ArrowRight size={16} />
        </Link>
      </section>

      {/* WHY THIS EXISTS — founder note */}
      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-14 border-t border-white/10">
        <div className="text-[#A855F7] uppercase text-xs tracking-widest mb-3">
          Why we made this
        </div>
        <h2 className="font-display text-4xl text-white leading-tight">
          Your car should feel <span className="text-neon-pink">a little more you</span>.
        </h2>
        <div className="text-white/70 mt-6 space-y-4 leading-relaxed">
          <p>
            Most car accessories are designed like the driver is picking up
            their grandmother from Bingo. But most drivers aren't. They stream
            explicit playlists. They date. They laugh at things they wouldn't
            say in front of their bosses.
          </p>
          <p>
            Booty Breeze is a small, bold, unapologetically-adult brand for
            those drivers. It's a joke your passenger sees before they hear it.
            It smells incredible. It's under nine bucks. And every hang is a
            small, deliberate "yes, I meant to buy this."
          </p>
          <p className="text-white">
            Thanks for being here. If a scent doesn't hit for you, email us at{" "}
            <a
              href="mailto:admin@bootybreeze.com"
              className="text-[#FF3D8B] hover:underline"
            >
              admin@bootybreeze.com
            </a>{" "}
            and we'll make it right.
          </p>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-20 text-center border-t border-white/10">
        <Sparkles className="mx-auto text-[#A855F7]" size={22} />
        <h2 className="font-display text-3xl sm:text-4xl text-white mt-4">
          Pick your mood. Hang it up.
        </h2>
        <Link
          to="/shop"
          data-testid="about-final-cta"
          className="pulse-pink mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#FF3D8B] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#ff5ba0] transition-colors"
        >
          Shop the collection <ArrowRight size={18} />
        </Link>
      </section>
    </div>
  );
}
